import saasApiClient from '../saasAplClient'
import { getRjmStateChangeObj, saasUserManagementClientStoreCredentialsCookieName } from '../stores/saasUserManagementClientStore'
import saasApiClientServerRequestQueue from '../saasApiClientServerRequestQueue'
import capacitorDetect from '../capacitorDetect.js'
import navigationStructure from '../navigationStructure.js'

import { prodDomain, preferredTenantName, saasServiceName } from '../constants.js'

const isVueRouterModeHash = false

let preferredFullLocation = 'https://' + prodDomain + '/#/' + preferredTenantName + '/'
if (!isVueRouterModeHash) {
  preferredFullLocation = 'https://' + prodDomain + '/' + preferredTenantName + '/'
}
export const projectName = 'saas_social' // Must match what is output from _repo_vars PROJECT_NAME

async function retrieveLoginFromCookieAndSaveToStateIfFound (rjmStateChange) {
  if (!await capacitorDetect.cookies.has(saasUserManagementClientStoreCredentialsCookieName)) {
    return // no cookie so do nothing
  }
  const cookieData = await capacitorDetect.cookies.get(saasUserManagementClientStoreCredentialsCookieName)
  if (typeof (cookieData) === 'undefined') {
    return // blanked cookie so do nothing (cookies are blanked when refresh fails)
  }
  if (typeof (cookieData.loginTenantName) === 'undefined') {
    // require cookie to have the loginTenantName
    return
  }
  if (cookieData.loginTenantName !== rjmStateChange.getFromState('loginService').tenantName) {
    // do not accept a cookie without a loginTenantName that matches this one
    return
  }
  // console.log('Cookie present', cookieData.jwtData)
  rjmStateChange.executeAction('setLoginFromCookie', { cookieData })

  // Matrix store will read it's cookie as well but seperatly
}

function actionsForLoggedInUser ({ to, rjmStateChange }) {
  // Empty function. Good place for loading logged in users details
}

async function notLoggedInBeforeEnter (to, from, next, rjmStateChange) {
  redirectionlogger('notLoggedInBeforeEnter')

  const notLoggedInPath = '/' + to.params.tenantName + '/notloggedin'
  const afterLoginPath = '/' + to.params.tenantName

  const sendUserToNotLoggedInPage = function () {
    sendUserToPage(to, next, notLoggedInPath, to.path)
    sendUserToLogin(to, rjmStateChange)
  }
  const sendUserToDefaultAfterLoginPage = function () {
    sendUserToPage(to, next, afterLoginPath)
  }

  const callback = {
    ok: function (response) {
      // At this point the retervial token and cookie has been read to see if user is logged in

      // console.log('sendUserToNotLoggedInPage callback OK')
      // Rather than check if user is logged in check they have the role hasaccount

      const hasAccount = rjmStateChange.getFromState('hasRole')('hasaccount')
      if (hasAccount) {
        if (to.path === notLoggedInPath) {
          console.log('about to sendUserToDefaultAfterLoginPage', to.path)
          sendUserToDefaultAfterLoginPage()
          return
        } else {
          actionsForLoggedInUser({ to, rjmStateChange })
          next()
          return
        }
      }

      // At this point we know the user has no login credentials
      if (navigationStructure.allowNotLoggedInForPath(to.params.tenantName, to.path)) {
        redirectionlogger('notLoggedInBeforeEnter - page is allowed for not logged in user')
        next()
        return
      }
      sendUserToNotLoggedInPage()
      console.log('sendUserToNotLoggedInPage callback OK END')
    },
    error: function (response) {
      console.log('ERROR router.js fds43 ERR', response)
      sendUserToNotLoggedInPage()
    }
  }
  redirectionlogger('Checking for jwtretervialtoken')
  if (typeof (to.query.jwtretervialtoken) === 'undefined') {
    redirectionlogger(' - jwtretervialtoken NOT FOUND')
    // console.log('Checking for logon cookie')
    if (rjmStateChange.getFromState('loginService').processState !== 0) return
    redirectionlogger(' - About to check from cookie')
    await retrieveLoginFromCookieAndSaveToStateIfFound(rjmStateChange)
    callback.ok('')
  } else {
    redirectionlogger(' - jwtretervialtoken FOUND - Detected return from login')
    // gtm not deployed yet
    // gtm.logEvent('login', 'LoginComplete', 'Done', 0)
    await rjmStateChange.executeAction('processRecievedJWTretervialtoken', {
      jwtretervialtoken: to.query.jwtretervialtoken,
      callback,
      curpath: to.path,
      startAllBackendCallQueuesFn: saasApiClientServerRequestQueue.getStartAllBackendCallQueuesFn({ curpath: to.path })
    })
  }
}

async function globalBeforeEnter (to, from, next, callSrc) {
  // redirectionlogger('globalBeforeEnter topath=' + to.path + ' source of globalBeforeEnter=' + callSrc)

  const x = redirectToProperDomain()
  if (x.wasRedirected) return
  if (redirectToURLWithExpandedCampaignParams()) return

  const rjmStateChange = getRjmStateChangeObj()
  saasApiClient.registerEndpointsWithStore({
    saasServiceName,
    getRjmStateChangeFn: getRjmStateChangeObj,
    prodDomain,
    runtype: x.runtype,
    tenantName: to.params.tenantName,
    doneFn: function () {
      saasApiClient.startEndpointIdentificationProcess({
        endpointName: saasServiceName,
        getRjmStateChangeFn: getRjmStateChangeObj
      })
    }
  })
  const rjmStateChange2 = getRjmStateChangeObj()
  if (rjmStateChange2.getFromState('isLoggedIn')) {
    actionsForLoggedInUser({ to, rjmStateChange })
    next()
  } else {
    await notLoggedInBeforeEnter(to, from, next, rjmStateChange)
  }
}

function redirectToURLWithExpandedCampaignParams () {
  const redirectUTMSource = 'social'
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('l')) {
    // Auto tag an internal campaign
    const newLocation = 'https://' + prodDomain + '/?utm_source=' + redirectUTMSource + '&utm_medium=' + urlParams.get('l') + '&utm_campaign=Internal%20app%20Share'
    redirectionlogger('redirectToURLWithExpandedCampaignParams->HREF(' + newLocation + ')')
    window.location.href = newLocation
    return true
  }
  return false
}

function sendUserToPage (to, next, targetPage, requestedPage) {
  if (to.path === targetPage) {
    // console.log('a')
    redirectionlogger('sendUserToPage->next()')
    next()
    return
  }
  if (typeof (requestedPage) !== 'undefined') {
    targetPage = targetPage + '?requestedPage=' + requestedPage
  }
  redirectionlogger('sendUserToPage->next(' + targetPage + ')')
  next({
    path: targetPage
  })
}

function sendUserToLogin (to, rjmStateChange) {
  const returnAddress = capacitorDetect.getPlatformReturnUrl(to.path)
  window.location.href = rjmStateChange.getFromState('getLoginUIURLFn')(undefined, '/', returnAddress)
}

function redirectToProperDomain () {
  // return
  // {
  //   wasRedirected: true if redirection is required, false otherwise
  //   runtype: 'proddomain' - if running in prodDomain, 'prodapi' if running in api.metcarob.com, 'dev' otherwise
  // }
  // host api.metcarob.com can never be http - kong will block
  // host www.thumbsum.co must be moved non-www and https if not already
  // host thumbsum.co must be moved to https if not
  // console.log('location.protocol:', location.protocol)
  // console.log('location.hostname:', location.hostname)
  const platform = capacitorDetect.getPlatform()
  if (platform !== 'pwa') {
    // Platform can be either 'android' or 'ios'
    return { wasRedirected: false, runtype: platform }
  }
  const subDomainsToRedirectFrom = ['www']
  let runtype = 'dev'
  const arrayLength = subDomainsToRedirectFrom.length
  for (let i = 0; i < arrayLength; i++) {
    if (location.hostname === subDomainsToRedirectFrom[i] + '.' + prodDomain) {
      redirectionlogger('redirectToProperDomain 1->HREF(' + preferredFullLocation + ')')
      window.location.href = preferredFullLocation
      return { wasRedirected: true }
    }
  }

  if (location.hostname === prodDomain) {
    if (location.protocol === 'http:') {
      redirectionlogger('redirectToProperDomain 2->HREF(' + preferredFullLocation + ')')
      window.location.href = preferredFullLocation
      return { wasRedirected: true }
    }
    runtype = 'proddomain'
  } else { // not prod domain
    if (location.hostname === 'api.metcarob.com') {
      runtype = 'prodapi'
    } else {
      if (location.hostname !== 'localhost') {
        if (location.hostname !== 'localhost:8080') {
          if (location.hostname !== '127.0.0.1') {
            if (location.hostname !== '127.0.0.1:8080') {
              // May be someone else hosting this code
              redirectionlogger('redirectToProperDomain 3->HREF(' + preferredFullLocation + ')')
              window.location.href = preferredFullLocation
              return { wasRedirected: true }
            }
          }
        }
      }
    }
  }
  return { wasRedirected: false, runtype }
}

const logger = function (msg, messagetype) {
  let log = true
  if (messagetype === 'redirect') {
    log = true
  }
  if (log) {
    console.log(messagetype, ':', msg)
  }
}
const redirectionlogger = function (msg) {
  logger(msg, 'redirect')
}

// function redirectToDefaultTenant (to, from, next) {
//   console.log('redirectToDefaultTenant AAAA')
//   redirectionlogger('redirectToDefaultTenant')
//   const x = redirectToProperDomain()
//   if (x.wasRedirected) return
//   if (redirectToURLWithExpandedCampaignParams()) return
//   // window.location.href = window.location.href + preferredTenantName + '/'
//   redirectionlogger('redirectToDefaultTenant - about to call sendUserToPage')
//   sendUserToPage(to, next, '/' + preferredTenantName + '/')
// }

function getGlobalBeforeEnterFn (callSrc) {
  return async function (to, from, next) {
    redirectionlogger('S-Start of GlobalBeforeEnterFn:' + callSrc)
    await globalBeforeEnter(to, from, next, callSrc)
    redirectionlogger('X-End of GlobalBeforeEnterFn:' + callSrc)
  }
}

const routes = [
  {
    path: '/',
    redirect: '/' + preferredTenantName + '/'
  },
  {
    path: '/:tenantName/',
    beforeEnter: getGlobalBeforeEnterFn('tenantRoot'),
    children: [
      {
        path: '', // /:tenantName/
        component: () => import('layouts/ChatLayout.vue'),
        beforeEnter: getGlobalBeforeEnterFn('mainChatLayout'),
        children: [
          {
            path: '',
            component: () => import('pages/IndexPage.vue'),
            beforeEnter: getGlobalBeforeEnterFn('Index')
          },
          {
            path: 'chatroom/:roomId',
            name: 'Chatroom',
            component: () => import('pages/ChatRoom.vue'),
            beforeEnter: getGlobalBeforeEnterFn('chatroom')
          }
        ]
      },
      {
        path: '', // same parent /:tenantName/, but with MainLayout
        component: () => import('layouts/MainLayout.vue'),
        beforeEnter: getGlobalBeforeEnterFn('mainMainLayout'),
        children: [
          { path: 'debug', name: 'Debug', component: () => import('pages/DebugPage.vue'), beforeEnter: getGlobalBeforeEnterFn('debug') },
          { path: 'about', name: 'About', component: () => import('pages/AboutPage.vue'), beforeEnter: getGlobalBeforeEnterFn('about') },
          { path: 'organiserfeatures', name: 'OrganiserFeatures', component: () => import('pages/OrganiserFeatures.vue'), beforeEnter: getGlobalBeforeEnterFn('OrganiserFeatures') },
          { path: 'privacy', name: 'privacy', component: () => import('pages/PrivacyPage.vue'), beforeEnter: getGlobalBeforeEnterFn('privacy') },
          { path: 'cssp', name: 'cssp', component: () => import('pages/CSSPolicyPage.vue'), beforeEnter: getGlobalBeforeEnterFn('cssp') },
          { path: 'tos', name: 'tos', component: () => import('pages/TosPage.vue'), beforeEnter: getGlobalBeforeEnterFn('tos') },
          { path: 'values', name: 'values', component: () => import('pages/ValuesPage.vue'), beforeEnter: getGlobalBeforeEnterFn('values') },
          { path: 'clubs', name: 'Clubs', component: () => import('pages/Clubs.vue'), beforeEnter: getGlobalBeforeEnterFn('clubs') },
          { path: 'clubs/:clubId', name: 'Club', component: () => import('pages/Club.vue'), beforeEnter: getGlobalBeforeEnterFn('club') },
          { path: 'clubs/clubnotfound', name: 'Club Not Found', component: () => import('pages/ClubNotFound.vue'), beforeEnter: getGlobalBeforeEnterFn('clubnotfound') },
          { path: 'events/:eventId', name: 'Event', component: () => import('pages/Event.vue'), beforeEnter: getGlobalBeforeEnterFn('event') },
          { path: 'promo/:eventId/:clubId', name: 'Promo', component: () => import('pages/Promo.vue'), beforeEnter: getGlobalBeforeEnterFn('event_promo') },
          { path: 'promoreg/:eventId/:clubId', name: 'PromoReg', component: () => import('pages/PromoReg.vue'), beforeEnter: getGlobalBeforeEnterFn('event_promoreg') },
          { path: 'profile', name: 'Profile', component: () => import('pages/Profile.vue'), beforeEnter: getGlobalBeforeEnterFn('profile') },
          { path: 'profile/deleteaccount', name: 'Delete Account', component: () => import('pages/DeleteAccountPage.vue'), beforeEnter: getGlobalBeforeEnterFn('deleteaccount') },
          { path: 'profile/deleteaccountconfirm', name: 'Account Deletion Confirmed', component: () => import('pages/DeleteAccountConfirmPage.vue'), beforeEnter: getGlobalBeforeEnterFn('deleteaccountconfirm') },
          { path: 'profile/adminreport', name: 'Make Report to SocialClubHub Admin', component: () => import('pages/AdminReportPage.vue'), beforeEnter: getGlobalBeforeEnterFn('adminreport') },
          { path: 'copyright', name: 'Copyright', component: () => import('pages/CopyrightPage.vue'), beforeEnter: getGlobalBeforeEnterFn('copyright') }
        ]
      }
    ]
  },
  { // By default I put users to /notfound
    path: '/:tenantName/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
